import { Mapper } from '../../../common/ddd/mapper.base';
import { formatDeviation } from '../../../common/utils/format-deviation.util';
import { SelfFocusScoreAggregateRoot } from '../../../core/domain/aggregates/scores/self-focus-score.aggregate-root';
import { GetSelfFocusScoreResponseDto } from '../../../interface/dtos/scores/self-get-focus-score.response.dto';

export type ISelfFocusScoreAggregateRootMapper = Mapper<
  SelfFocusScoreAggregateRoot,
  GetSelfFocusScoreResponseDto
>;

export class SelfFocusScoreAggregateRootMapper
  implements Omit<ISelfFocusScoreAggregateRootMapper, 'toDomain'>
{
  toResponse(
    entity: SelfFocusScoreAggregateRoot
  ): GetSelfFocusScoreResponseDto {
    return SelfFocusScoreAggregateRootMapper.toResponse(entity);
  }

  static toResponse(
    entity: SelfFocusScoreAggregateRoot
  ): GetSelfFocusScoreResponseDto {
    return {
      value: `${entity.thisPeriodFocusScore}`,
      unformattedValue: entity.thisPeriodFocusScore,
      allTimeAverage: entity.allTimeAverageFocusScore.toString(),
      max: entity.allTimeMaxFocusScore.toString(),
      deviationFromAveragePercentage: formatDeviation(
        entity.deviationFromAvereagePercentage
      ),
      name: entity.name,
    };
  }
}
